import shajs from 'sha.js';

export const sha256 = async (message) => shajs('sha256').update(message).digest('hex');
